import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import OcurrenceRepository from '@/shared/http/repositories/realestate/ocurrence'
import { toast, loading } from '@/shared/utils/UIHelper'
import inputnewboll from '@/views/private/realestate/ocurrence/components/addocurrence/components/inputnewboll.vue'
import agendatechnical from './agendatechnical/agendatechnical.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: 'TechnicalVisit',
  mixins: [ActionsForm, ExpenseMixin],
  props:
  {
    dataDetails: {
      type: Object,
      default: {}
    },
    statusOcorencia: {
      type: Number,
      default: 0
    }
  },

  components: {
    HeadDetailsGama,
    inputnewboll,
    agendatechnical,
    Multiselect
  },
  data () {
    return {
      head: ['Descrição', 'Ótimo', 'Bom', 'Regular', 'Ruim'],
      status: '',
      escritoBotao: true,
      resumo: false,
      databrower: [],
      flDisable: false,
      problemaRaizArray: [],
      dataAllPatologia: [],
      teste: [],
      otimo: false,
      bom: false,
      regular: false,
      ruim: false,
      QualidadeOption: null,
      editarAvaliacao: false,
      dadosDetails: {},
      validaAgenda: false
    }
  },
  watch: {
    statusOcorencia (newvalue) {
      this.flDisable = newvalue >= 3 || newvalue < 0
      this.editarAvaliacao = !this.flDisable
    }
  },
  mounted () {
    this.GetProblemaRaiz()
    this.GetAllPatologia()
    this.flDisable = this.statusOcorencia >= 3 || this.statusOcorencia < 0
    this.getVistoriaById(this.dataDetails)
  },
  methods: {
    // mapPatologiasToMultiselect () {
    //   // Certifique-se de que ambos os arrays estão preenchidos
    //   if (!this.dataAllPatologia || !this.dataAllPatologia.length || !this.dataDetails.patologias || !this.dataDetails.patologias.length) return

    //   this.dataDetails.patologias = this.dataDetails.patologias
    //     .map(p => {
    //       return this.dataAllPatologia.find(option => option.value === p.patalogia)
    //     })
    //     .filter(Boolean) // Remove undefined caso não encontre correspondência
    // },
    getVistoriaById (e) {
      let id = e.id
      OcurrenceRepository.GetVistoriaById(id)
        .then((res) => {
          this.dataDetails = res.data
        })
        .catch(() => {})
    },
    addTag (newTag) {
      const tag = {
        text: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    },
    GetAllPatologia () {
      loading.push()
      OcurrenceRepository.GetPatologia()
        .then((Response) => {
          loading.pop()
          this.dataAllPatologia = Response.data
          // this.mapPatologiasToMultiselect()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    openfilevistoria () {
      let file = document.getElementById('pdf-vistoria')
      if (this.flDisable) return
      file.click()
    },
    SendFileVistoriaTecnica (file) {
      if (this.flDisable) return
      let formdata = new FormData()
      formdata.append('file', file.target.files[0])
      loading.push()
      OcurrenceRepository.SendFileVistoriaTecnica(this.dataDetails.id, formdata)
        .then((Response) => {
          loading.pop()
          if (Response.data != null) {
            toast.success('Pdf salvo com sucesso!!')
            this.dataDetails.fileVistoriaId = Response.data.filePdfVistoriaId
            this.dataDetails.nomeFileVistoria = Response.data.nameArquivo
          }
        })
        .catch((Error) => {
          loading.pop()
          toast.error(Error.response.data)
        })
    },
    downloadFileVistoria () {
      loading.push()
      OcurrenceRepository.DownloadFileVistoria(this.dataDetails.fileVistoriaId)
        .then((Response) => {
          loading.pop()
          let base64 = Response.data
          let a = document.createElement('a')
          a.href = 'data:application/pdf;base64,' + base64
          a.download = this.dataDetails.nomeFileVistoria
          a.click()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    deletepdfvistoria () {
      loading.push()
      OcurrenceRepository.DeleteFileVistoriaTecnica(this.dataDetails.id)
        .then((Response) => {
          if (Response.data) {
            this.dataDetails.fileVistoriaId = null
            toast.success('PDF Deletado com sucesso!!')
          }

          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
          toast.success('Não foi possivel deletar o PDF!!')
        })
    },
    onSubmit (e) {
      // let trocadeaba = 2
      loading.push()
      this.dadosDetails = e
      if (e.dataSolicitacao != null && e.dataSolicitacao !== undefined) {
        this.validadiavisita(e.dataSolicitacao)
      }
      if (this.dadosDetails.tecnicoId == null && this.dataDetails.tecnicoId !== null) {
        this.dadosDetails.tecnicoId = this.dataDetails.tecnicoId
        this.dadosDetails.tecnico = this.dataDetails.tecnico
      }
      if (this.dadosDetails.engenheiroId == null && this.dataDetails.engenheiroId !== null) {
        this.dadosDetails.engenheiroId = this.dataDetails.engenheiro.id
        this.dadosDetails.engenheiro = this.dataDetails.engenheiro
      }
      if (this.validaAgenda === false) {
        loading.pop()
        toast.error('Preencha a data e o horário da vistoria!')
      } else {
        this.$validator.validateAll().then(result => {
          if (!result) {
            return
          }
          console.log(this.dadosDetails)
          if (this.dadosDetails.dataSolicitacao !== null &&
            this.dadosDetails.horario !== null &&
            (this.dadosDetails.engenheiro != null && this.dadosDetails.engenheiro !== '') &&
            (this.dadosDetails.tecnicoId != null && this.dadosDetails.tecnicoId !== '')) {
            this.validaAgenda = true
            this.dataDetails.validate = true
            let trocadeaba = 2
            console.log(this.dadosDetails)
            OcurrenceRepository.PutVistoria(this.dadosDetails)
              .then(res => {
                if (res.status === 200) {
                  this.resumo = !this.resumo
                  this.$emit('resumo', this.resumo)
                  toast.success(`Alterações salvas com sucesso`)
                  this.$emit('updateView', false)
                  this.$emit('goToInputCost', trocadeaba)
                  loading.pop()
                }
              })
              .catch(() => {
                toast.error(`Erro ao salvar mudanças`)
                loading.pop()
              })
          } else {
            console.log(this.dadosDetails)
            if (this.dadosDetails.horario == null) {
              toast.error('Selecione um Horario!!')
            }
            if (this.dadosDetails.dataSolicitacao == null) {
              toast.error('Selecione uma Data!!')
            }
            if (this.dadosDetails.tecnicoId == null || this.dadosDetails.tecnicoId === '') {
              toast.error('Selecione um Técnico!!')
            }
            if (this.dadosDetails.engenheiro == null || this.dadosDetails.engenheiro === '') {
              toast.error('Selecione um Engenheiro!!')
            }
            this.validaAgenda = false
            loading.pop()
          }
        })
      }
    },
    setgarantiavistoria (e) {
      this.dataDetails.garantiaVistoria = e
    },
    verificaManutencao () {
      if (this.dataDetails.manutencaoCompleta === true) {
        this.dataDetails.manutencaoIncompleta = false
        this.dataDetails.manutencaoCompleta = false
      } else {
        if (this.dataDetails.manutencaoIncompleta === true) {
          this.dataDetails.manutencaoCompleta = false
          this.dataDetails.manutencaoIncompleta = false
        }
      }
    },
    verificaTratamento () {
      if (this.dataDetails.tratamentoProcedente === true) {
        this.dataDetails.tratamentoImprocedente = false
        this.dataDetails.tratamentoProcedente = false
      } else {
        if (this.dataDetails.tratamentoImprocedente === true) {
          this.dataDetails.tratamentoProcedente = false
          this.dataDetails.tratamentoImprocedente = false
        }
      }
    },
    GetProblemaRaiz () {
      loading.push()
      OcurrenceRepository.GetProblemaRaiz()
        .then(Response => {
          this.problemaRaizArray = Response.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    setGarantia (newvlaue) {
      this.dataDetails.garantia = newvlaue
      if (this.dataDetails.garantia === true) {
        this.dataDetails.cortesia = false
        this.dataDetails.apenasOrcamento = false
      }
    },
    setManutencaocortesia (value) {
      this.dataDetails.cortesia = value
    },
    validadiavisita (value) {
      if (typeof value === 'string') {
        let datetime = new Date(value)
        let diaSelecionado = datetime.getDate()
        let dataAtual = new Date()
        let diaAtual = dataAtual.getDate()
        let mesAtual = new Date().getMonth()
        let monthSelect = datetime.getMonth()
        let yearSelect = datetime.getFullYear()
        let yearAtual = new Date().getFullYear()
        if (yearSelect >= yearAtual) {
          if (monthSelect >= mesAtual) {
            if (diaSelecionado >= diaAtual) {
              this.validaAgenda = true
            } else {
              this.validaAgenda = false
            }
          } else {
            this.validaAgenda = false
          }
        } else {
          this.validaAgenda = false
        }
      } else {
        let diaSelecionado = value.getDate()
        let dataAtual = new Date()
        let diaAtual = dataAtual.getDate()
        let mesAtual = new Date().getMonth()
        let monthSelect = value.getMonth()
        let yearSelect = value.getFullYear()
        let yearAtual = new Date().getFullYear()
        if (yearSelect >= yearAtual) {
          if (monthSelect >= mesAtual) {
            if (diaSelecionado >= diaAtual) {
              this.validaAgenda = true
            } else {
              this.validaAgenda = false
            }
          } else {
            this.validaAgenda = false
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/technicalvisit/technicalvisit.js